<script>
import usePlanManagement from "@/composables/financial_management/functional_information/plan_management/usePlanManagement"

export default {
  async mounted() {
    await this.fetchData()
  },

  data() {
    return {
      ...usePlanManagement().data()
    }
  },

  methods: {
    ...usePlanManagement().methods,
  }
}
</script>

<template>
  <div class="p-3">
    <div class="table-container">
      <div class="table-responsive" v-if="years?.length > 0">
        <table class="table c-table">
          <thead>
          <tr>
            <th class="sticky-column first-col" rowspan="2">ماهیت پروژه</th>
            <th class="sticky-column second-col" rowspan="2">عنوان پروژه</th>
            <th class="sticky-column third-col" rowspan="2">واحد (مثال: متر مربع، کیلومتر و ...)</th>
            <th :colspan="years.length">حجم عملیات سالانه ۱</th>
            <th :colspan="years.length">پیشرفت فیزیکی ۲</th>
            <th :colspan="years.length">مخارح سالانه طرح 3</th>
            <th :colspan="years.length">سهم طرح از بهای تمام شده و هزینه‌های اداری، عمومی و فروش 4</th>
            <th :colspan="years.length">سهم طرح از نیروی انسانی 5</th>
          </tr>
          <tr>
            <!-- سال‌های بخش حجم عملیات -->
            <template v-for="year in years" :key="`operation-${year}`">
              <th>سال {{ year }}</th>
            </template>
            <!-- سال‌های بخش پیشرفت فیزیکی -->
            <template v-for="year in years" :key="`progress-${year}`">
              <th>سال {{ year }}</th>
            </template>
            <!-- سال‌های بخش مخارح سالانه طرح -->
            <template v-for="year in years" :key="`cost-${year}`">
              <th>سال {{ year }}</th>
            </template>
            <!-- سال‌های بخش سهم طرح از بهای تمام شده و هزینه‌های اداری، عمومی و فروش -->
            <template v-for="year in years" :key="`finished-prices-plan-share-${year}`">
              <th>سال {{ year }}</th>
            </template>
            <!-- سال‌های بخش سهم طرح از نیروی انسانی -->
            <template v-for="year in years" :key="`contribution-plan-share-${year}`">
              <th>سال {{ year }}</th>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in plans" :key="index">
            <td class="sticky-column first-col">{{ row.nature }}</td>
            <td class="sticky-column second-col">{{ row.title }}</td>
            <td class="sticky-column third-col">{{ row.unit }}</td>

            <!-- حجم عملیات سالانه -->
            <td v-for="year in years" :key="`operation-${year}`">
              <input
                  type="number"
                  class="form-control form-control-sm text-center"
                  :value="row.annual_operations[year]"
                  @input="(e) => handleYearlyValueChange(row, 'annual_operations', year, e.target.value)"
              />
            </td>

            <!-- پیشرفت فیزیکی -->
            <td v-for="year in years" :key="`progress-${year}`">
              <input
                  type="number"
                  step=".01"
                  class="form-control form-control-sm text-center"
                  :value="row.physical_progress[year]"
                  @input="(e) => handleYearlyValueChange(row, 'physical_progress', year, e.target.value)"
              />
            </td>

            <!-- مخارح سالانه طرح -->
            <td v-for="year in years" :key="`cost-${year}`">
              <input
                  type="number"
                  class="form-control form-control-sm text-center"
                  :value="row.annual_cost_plan[year]"
                  @input="(e) => handleYearlyValueChange(row, 'annual_cost_plan', year, e.target.value)"
              />
            </td>

            <!-- سهم طرح از بهای تمام شده و هزینه‌های اداری، عمومی و فروش -->
            <td v-for="year in years" :key="`finished-prices-plan-share-${year}`">
              <input
                  type="number"
                  class="form-control form-control-sm text-center"
                  :value="row.finished_prices_plan_share[year]"
                  @input="(e) => handleYearlyValueChange(row, 'finished_prices_plan_share', year, e.target.value)"
              />
            </td>

            <!-- سهم طرح از نیروی انسانی -->
            <td v-for="year in years" :key="`contribution-plan-share-${year}`">
              <input
                  type="number"
                  class="form-control form-control-sm text-center"
                  :value="row.contribution_plan_share[year]"
                  @input="(e) => handleYearlyValueChange(row, 'contribution_plan_share', year, e.target.value)"
              />
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="alert alert-info m-3">
        موردی وجود ندارد
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-control-sm {
  height: 2vw;
  padding: .2vw .5vw;
}

.table td,
.table th {
  text-align: right;
  min-width: 5vw;
}

.table input[type="number"] {
  text-align: center;
  min-width: 9vw;
}

/* To remove the numeric Input Flash */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table-responsive::-webkit-scrollbar {
  height: 0.6vw;
}

th.sticky-column,
td.sticky-column {
  position: sticky;
  right: -.1vw;
  z-index: 3;
  box-shadow: inset .4vw 0 .4vw -.4vw rgba(255, 255, 255, 0.4);
}

tbody > tr:nth-child(odd) > td.sticky-column {
  background-color: #86d1fc;
}

tbody > tr:nth-child(even) > td.sticky-column {
  background-color: #bde6fe;
}

.first-col {
  right: 0;
  z-index: 3;
}

.second-col {
  right: 4.8vw !important;
  z-index: 2;
  min-width: 15vw !important;
}

.third-col {
  right: 19.7vw !important;
  z-index: 1;
}
</style>
